export default "__VITE_ASSET__CeXC9AVY__"